import { render, staticRenderFns } from "./WhatsappV2.vue?vue&type=template&id=37e00e27"
import script from "./WhatsappV2.vue?vue&type=script&lang=js"
export * from "./WhatsappV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports